module.exports = __webpack_public_path__ + "c73126337adf262862c36210949e189e.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/michael-henretty.jpg
// module id = 448
// module chunks = 0